import { VoucherPurchaseStep } from '@/data/enums/voucherPurchaseSteps'

export const isHomePage = (path: string) => {
    return ['/welcome', '/welcome-with-services'].includes(path)
}

export const isConnectivityIssuesPage = (path: string) => {
    return ['/connectivity-issues'].includes(path)
}

/** Steps that are valid while mounted on the payment / cash routes. */
export const PAYMENT_ROUTE_STEPS: ReadonlySet<VoucherPurchaseStep> = new Set([
    VoucherPurchaseStep.INSERT_CASH,
    VoucherPurchaseStep.CARD_PAYMENT,
    VoucherPurchaseStep.PROCESS_PAYMENT,
    VoucherPurchaseStep.DEPOSIT_SUCCESS_ANIMATION,
    VoucherPurchaseStep.REFERRAL_INTRO,
    VoucherPurchaseStep.PRINT_VOUCHER,
    VoucherPurchaseStep.VOUCHER_CONFIRMATION,
    VoucherPurchaseStep.VOUCHER_ERROR,
    VoucherPurchaseStep.PROMO_VOUCHER_ERROR,
    VoucherPurchaseStep.COMPLETE
])

export const isValidPaymentRouteStep = (step: VoucherPurchaseStep) =>
    PAYMENT_ROUTE_STEPS.has(step)
